import {SocialNetworks, handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {SHARE_BUTTON_NAMES, getEventPageUrl} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {getMultilingual} from '../../../../../commons/selectors/environment'
import {getEventUrl} from '../../../../../commons/selectors/event'
import {getShareUrls} from '../../../../../commons/services/share'
import {Facebook as FacebookIcon} from '../../../../../icons/Facebook'
import {Linkedin as LinkedinIcon} from '../../../../../icons/Linkedin'
import {X as XIcon} from '../../../../../icons/X'
import {useAppActions, useAppPageUrl, useAppSelector} from '../../hooks/runtime'
import {getEvent} from '../../selectors/event'
import cl from '../classnames.scss'
import {SocialShareProps} from './interfaces'
import s from './social-share.scss'

const {Facebook, LinkedIn, Twitter: X} = SocialNetworks

export const SocialShare = ({page, margin}: SocialShareProps) => {
  const {t} = useTranslation()
  const {shareEvent} = useAppActions()

  const pageUrl = useAppPageUrl()
  const event = useAppSelector(getEvent)
  const multilingual = useAppSelector(getMultilingual)

  const eventUrl = event.eventPageUrl?.base ? getEventPageUrl(event) : getEventUrl(pageUrl, event, multilingual)
  const shareUrls = getShareUrls(eventUrl, t)

  const shareOnFacebook = () => {
    shareEvent({buttonName: SHARE_BUTTON_NAMES.FACEBOOK, origin: page})
  }

  const shareOnX = () => {
    shareEvent({buttonName: SHARE_BUTTON_NAMES.X, origin: page})
  }

  const shareOnLinkedin = () => {
    shareEvent({buttonName: SHARE_BUTTON_NAMES.LINKEDIN, origin: page})
  }

  const iconsMeasurements = {
    [Facebook]: {width: '19', height: '16'},
    [X]: {width: '19', height: '16'},
    [LinkedIn]: {width: '19', height: '16'},
  }

  return (
    <div className={classNames(s.shareIcons, cl.socialShare)} data-hook="social-share">
      <a
        target="_blank"
        href={shareUrls[Facebook]}
        className={s.shareIcon}
        data-hook="social-share-icon-facebook"
        tabIndex={0}
        aria-label={t('a11y.shareButtonLabel', {
          button: 'Facebook',
        })}
        rel="noreferrer"
        onClick={shareOnFacebook}
        onKeyPress={handleKeyPressEnterOrSpace(shareOnFacebook)}
      >
        <FacebookIcon {...iconsMeasurements[Facebook]} />
      </a>
      <a
        target="_blank"
        href={shareUrls[X]}
        className={s.shareIcon}
        data-hook="social-share-icon-twitter"
        style={{margin: `0 ${margin || 30}px`}}
        tabIndex={0}
        aria-label={t('a11y.shareButtonLabel', {
          button: 'X',
        })}
        rel="noreferrer"
        onClick={shareOnX}
        onKeyPress={handleKeyPressEnterOrSpace(shareOnX)}
      >
        <XIcon {...iconsMeasurements[X]} />
      </a>
      <a
        target="_blank"
        href={shareUrls[LinkedIn]}
        className={s.shareIcon}
        data-hook="social-share-icon-linkedin"
        tabIndex={0}
        aria-label={t('a11y.shareButtonLabel', {
          button: 'LinkedIn',
        })}
        rel="noreferrer"
        onClick={shareOnLinkedin}
        onKeyPress={handleKeyPressEnterOrSpace(shareOnLinkedin)}
      >
        <LinkedinIcon {...iconsMeasurements[LinkedIn]} />
      </a>
    </div>
  )
}
